document.addEventListener("DOMContentLoaded", () => {

    const popup = document.getElementById("bundler-popup");
    const popupBody = document.getElementById("bundler-popup-target");

    const closeBtn = popup.querySelector(".bundler-popup__close");
    const overlay = popup.querySelector(".bundler-popup__overlay");

    const waitForBundler = setInterval(() => {

        const bundler = document.querySelector(".bundler-target-element");

        if (!bundler) return;

        clearInterval(waitForBundler);

        popupBody.appendChild(bundler);

        if (!sessionStorage.getItem("bundler-popup-shown")) {

    setTimeout(() => {

        popup.classList.add("active");
        document.body.classList.add("bundler-popup-open");

        sessionStorage.setItem("bundler-popup-shown", "true");

    }, 23000);

}

    },300);

    function closePopup(){

        popup.classList.remove("active");

        document.body.classList.remove("bundler-popup-open");

    }

    closeBtn.addEventListener("click",closePopup);

    overlay.addEventListener("click",closePopup);

    document.addEventListener("keydown",(e)=>{

        if(e.key==="Escape"){

            closePopup();

        }

    });

});